module.exports = __webpack_public_path__ + "img/click-right-top.418f2c15.png";